import { render, staticRenderFns } from "./NewProblemView.vue?vue&type=template&id=a3363bde&scoped=true&"
import script from "./NewProblemView.vue?vue&type=script&lang=js&"
export * from "./NewProblemView.vue?vue&type=script&lang=js&"
import style0 from "./NewProblemView.vue?vue&type=style&index=0&id=a3363bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3363bde",
  null
  
)

component.options.__file = "NewProblemView.vue"
export default component.exports